// extracted by mini-css-extract-plugin
export default {"container":"dY-z","title":"eY-z","link":"fY-z"};